<template>
    <div>
        <v-row>
            <v-col cols="8"></v-col>
            <v-col cols="4">
                <v-text-field
                    v-model="form_search_singlepart"
                    label="Search Singlepart / Enter"
                    single-line
                    solo
                    rounded
                    dense
                    @keyup.enter="func_search_sg()"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-card outlined class="mar-t-10">
            <v-row>
                <v-col cols="6">
                    <v-list-item>
                        <span class="headline">
                            <span class="primary--text">{{
                                form_query.part.singlepart
                            }}</span></span
                        ></v-list-item
                    >
                </v-col>
                <v-col cols="6" v-if="chk_edit_sn == false">
                    <v-list-item>
                        <span class="headline">
                            <span class="primary--text">{{
                                form_query.part.serial
                            }}</span></span
                        >
                        <v-btn
                            x-small
                            fab
                            class="ml-1"
                            v-if="team_name === 'INVENTORY'"
                            color="amber"
                            @click="func_edit_serial()"
                        >
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </v-list-item>
                </v-col>
                <v-col cols="3" v-if="chk_edit_sn == true">
                    <v-text-field
                        label="Solo"
                        v-model="form_query.part.serial"
                        solo
                        dense
                    ></v-text-field>
                </v-col>
                <v-col cols="1" v-if="chk_edit_sn == true">
                    <v-btn
                        :disabled="form_query.part.serial.length == 0"
                        x-small
                        fab
                        v-if="team_name === 'INVENTORY'"
                        color="green accent-3"
                        class="mt-1"
                        @click="save_edit_serial()"
                    >
                        <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row class="mar-t-30">
                <v-col cols="4" v-if="form_query.part">
                    <v-list-item three-line>
                        <v-list-item-content>
                            <div class="overline mb-4">
                                {{ form_query.part.category_name }}
                            </div>
                            <v-list-item-title class="headline mb-1">{{
                                form_query.part.part_description
                            }}</v-list-item-title>
                            <v-list-item-subtitle>{{
                                form_query.part.part_name
                            }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col cols="4">
                    <v-list-item three-line>
                        <v-list-item-content>
                            <div class="overline mb-4">
                                SUPPLIER : {{ form_query.part.supplier_name }}
                            </div>
                            <v-list-item-title class="headline mb-1">{{
                                form_query.part.project_name
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col cols="4">
                    <v-list-item three-line>
                        <v-list-item-content>
                            <div class="overline mb-4">
                                BRANCH : {{ form_query.part.branch_name }}
                            </div>
                            <v-list-item-title class="headline mb-1">
                                {{ form_query.part.status }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
            </v-row>
        </v-card>

        <v-row>
            <v-col
                cols="12"
                v-for="(row, index) in form_query.log"
                :key="index"
                :class="index > 0 ? 'mar-t-20' : 'mt-2'"
            >
                <h3>{{ index + 1 }}.{{ row.type }}</h3>
                <v-simple-table class="table-inv" v-if="row.type == 'stockin'">
                    <template v-slot:default>
                        <thead>
                            <tr class="col-tr-1">
                                <th class="text-center">Shipment</th>
                                <th class="text-center">
                                    Stockin
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>{{ row.detail.shipment }}</td>
                                <td class="text-center">
                                    <v-chip
                                        small
                                        color="amber"
                                        class="mt-1 mb-1"
                                        >{{ row.detail.stockin_name }}</v-chip
                                    >
                                    <br />
                                    <v-chip small class="mb-1">{{
                                        row.detail.stockin_date
                                    }}</v-chip>
                                </td>
                            </tr>
                            <br />
                        </tbody>
                    </template>
                </v-simple-table>

                <v-simple-table class="table-inv" v-if="row.type == 'transfer'">
                    <template v-slot:default>
                        <thead>
                            <tr class="col-tr-1">
                                <th class="text-center">Created</th>
                                <th class="text-center">Transfer To</th>
                                <th class="text-center">Packing</th>
                                <th class="text-center">Packing By</th>
                                <th class="text-center">Receive</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td class="text-center">
                                    <v-chip
                                        small
                                        color="amber"
                                        class="mt-1 mb-1"
                                        >{{ row.detail.created_name }}</v-chip
                                    >
                                    <br />
                                    <v-chip small class="mb-1">{{
                                        row.detail.created_date
                                    }}</v-chip>
                                </td>
                                <td>{{ row.detail.transfer_to }}</td>
                                <td>{{ row.detail.packing_no }}</td>
                                <td class="text-center">
                                    <v-chip
                                        small
                                        color="amber"
                                        class="mt-1 mb-1"
                                        v-if="row.detail.packing_name != null"
                                        >{{ row.detail.packing_name }}</v-chip
                                    >
                                    <br />
                                    <v-chip
                                        small
                                        class="mb-1"
                                        v-if="row.detail.packing_name != null"
                                        >{{ row.detail.packing_date }}</v-chip
                                    >
                                </td>
                                <td class="text-center">
                                    <v-chip
                                        small
                                        color="amber"
                                        class="mt-1 mb-1"
                                        v-if="row.detail.receive_name != null"
                                        >{{ row.detail.receive_name }}</v-chip
                                    >
                                    <br />
                                    <v-chip
                                        small
                                        class="mb-1"
                                        v-if="row.detail.receive_name != null"
                                        >{{ row.detail.receive_date }}</v-chip
                                    >
                                </td>
                            </tr>
                            <br />
                        </tbody>
                    </template>
                </v-simple-table>

                <v-simple-table class="table-inv" v-if="row.type == 'issue'">
                    <template v-slot:default>
                        <thead>
                            <tr class="col-tr-1">
                                <th class="text-center">Case Id</th>
                                <th class="text-center">Site</th>
                                <th class="text-center">Branch</th>
                                <th class="text-center">Engineer</th>
                                <th class="text-center">Status</th>
                                <th class="text-center">Issue Sn</th>
                                <th class="text-center">Issue From Branch</th>
                                <th class="text-center">Created</th>
                                <th class="text-center">Packing</th>
                                <th class="text-center">Packing By</th>
                                <th class="text-center">Onhand</th>
                                <th class="text-center">Onsite Date</th>
                                <th class="text-center">Ce Status</th>
                                <th class="text-center">Return No</th>
                                <th class="text-center">Ce Return Date</th>
                                <th class="text-center">Receive</th>
                                <th class="text-center">Receive By</th>
                                <th class="text-center">Packing Status</th>
                                <th class="text-center">Packing Remark</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>{{ row.detail.case_id }}</td>
                                <td>{{ row.detail.site_name }}</td>
                                <td>{{ row.detail.branch_name }}</td>
                                <td>{{ row.detail.engineer_name }}</td>
                                <td>{{ row.detail.status }}</td>
                                <td>{{ row.detail.issue_sn }}</td>
                                <td>{{ row.detail.issue_from_branch_name }}</td>
                                <td class="text-center">
                                    <v-chip
                                        small
                                        color="amber"
                                        class="mt-1 mb-1"
                                        v-if="row.detail.created_name != null"
                                        >{{ row.detail.created_name }}</v-chip
                                    >
                                    <br />
                                    <v-chip
                                        small
                                        class="mb-1"
                                        v-if="row.detail.created_name != null"
                                        >{{ row.detail.created_date }}</v-chip
                                    >
                                </td>
                                <td>{{ row.detail.packing_no }}</td>
                                <td class="text-center">
                                    <v-chip
                                        small
                                        color="amber"
                                        class="mt-1 mb-1"
                                        v-if="row.detail.packing_name != null"
                                        >{{ row.detail.packing_name }}</v-chip
                                    >
                                    <br />
                                    <v-chip
                                        small
                                        class="mb-1"
                                        v-if="row.detail.packing_name != null"
                                        >{{ row.detail.packing_date }}</v-chip
                                    >
                                </td>
                                <td class="text-center">
                                    <v-chip
                                        small
                                        color="amber"
                                        class="mt-1 mb-1"
                                        v-if="row.detail.onhand_name != null"
                                        >{{ row.detail.onhand_name }}</v-chip
                                    >
                                    <br />
                                    <v-chip
                                        small
                                        class="mb-1"
                                        v-if="row.detail.onhand_name != null"
                                        >{{ row.detail.onhand_date }}</v-chip
                                    >
                                </td>
                                <td>{{ row.detail.onsite_date }}</td>
                                <td>{{ row.detail.ce_status }}</td>
                                <td>{{ row.detail.return_no }}</td>
                                <td>{{ row.detail.ce_return_date }}</td>
                                <td>{{ row.detail.receive_sn }}</td>
                                <td class="text-center">
                                    <v-chip
                                        small
                                        color="amber"
                                        class="mt-1 mb-1"
                                        v-if="row.detail.receive_name != null"
                                        >{{ row.detail.receive_name }}</v-chip
                                    >
                                    <br />
                                    <v-chip
                                        small
                                        class="mb-1"
                                        v-if="row.detail.receive_name != null"
                                        >{{ row.detail.receive_date }}</v-chip
                                    >
                                </td>
                                <td class="text-center">
                                    {{ row.detail.receive_status }}
                                </td>
                                <td>{{ row.detail.receive_remark }}</td>
                            </tr>
                            <br />
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>
        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
let url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    watch: {
        "$route.query.q": function(val) {
            this.search = val
            this.get_data()
        },
    },
    computed: {
        ...mapState(["snackbar"]),
    },
    mounted() {
        this.search = this.$route.query.q
        this.get_data()
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        async get_data() {
            await axios
                .get(url + "inventory/history/" + this.search)
                .then((response) => {
                    this.form_query = response.data.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        func_edit_serial() {
            this.chk_edit_sn = true
        },
        async save_edit_serial() {
            let send = {
                serial: this.form_query.part.serial,
                singlepart: this.search,
            }
            await axios
                .post(url + "inventory/update-serial-part/", send)
                .then((response) => {
                    this.mutatesnackbar()
                    this.chk_edit_sn = false
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async func_search_sg() {
            // this.form_search_singlepart = ""
            let routeData = this.$router.resolve({
                path: "/Search-Parts",
                query: { q: this.form_search_singlepart },
            })
            window.open(routeData.href, "_blank")
        },
    },
    data() {
        return {
            form_query: [],
            search: "",
            team_name: localStorage.team_name,
            chk_edit_sn: false,
            text: "Success, Your work has been saved",
            form_search_singlepart: "",
        }
    },
}
</script>
